export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8078.f6ca5e85.jpg";